'use strict';

/**
 * Calls the API endpoint to trigger the prepare checkout process
 */
export function prepareCheckout() {
  let cartContents = localStorage.getItem('iconStoreCart');
  if (cartContents) {
    cartContents = JSON.parse(cartContents);
    // Build request
    let requestBody = {
      'cart': cartContents.items,
      'checkout_flag': window.location.pathname.indexOf('/checkout') !== -1,
    };
    // Make request
    fetch(`${window.location.origin}/prepare-checkout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody),
    })
    .then((response) => response.json())
    .then(data => {
      if (data.redirect) {
        window.location = data.redirect;
      }
      if (data.message) {
        // Close the cart
      }
    });
  }
}

export function prepareInvoiceCheckout(invoiceId) {
  // Make request
  fetch(`${window.location.origin}/prepare-checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ 'invoice': invoiceId }),
  })
  .then((response) => response.json())
  .then(data => {
    if (data.redirect) {
      window.location = data.redirect;
    }
    if (data.message) {
      // Close the cart
    }
  });
}

/**
 * Returns a number formatted with commas and decimal points
 *
 * @param number
 * @returns {string}
 */
export function formatCurrency(number) {
  return number.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});
}
